import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import MultiSelectBox from '../../../../../../../features/components/Form/MultiSelectBox'
import FieldLabelWrapper from '../../../../../../../features/components/Form/FieldLabelWrapper'

import { useLoadFacebookInterests } from '../../../../../hooks'

import { choicesInterestsLoadingSelector } from '../../../../../../../modules/selectors/choices'

import { INTERESTS } from '../../../../../../ReusableFormFields/InterestsFields/fields'

const InterestsContent = ({ values, setFieldValue }) => {
  const { t } = useTranslation()

  const interestsLoading = useSelector(choicesInterestsLoadingSelector)

  const { formattedInterests, searchInterests } = useLoadFacebookInterests()

  return (
    <FieldLabelWrapper label={t('Interests')}>
      <MultiSelectBox
        placeholder={t('ADD AN INTEREST')}
        name={INTERESTS}
        options={formattedInterests}
        value={values[INTERESTS]}
        isLoading={interestsLoading}
        onSearch={searchInterests}
        setFieldValue={setFieldValue}
      />
    </FieldLabelWrapper>
  )
}

export default InterestsContent
